import React, { useState, useReducer, useEffect } from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Button,
  Modal,
} from "react-bootstrap";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import axios from "../../../../../config/axios";
import moduleConfig from "../../moduleConfig";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import { ContainerLoading } from "../../../../UI/loading/ContainerLoading";
import GalleryItem from "./GalleryPicture";
import ReactFancyBox from "react-fancybox";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import AddFossilPicture from "./AddFossilPicture";
import { getCurrencyCode } from "../../../../../helpers/CommonHelper";
import {
  detailsInitialState,
  detailsReducer,
} from "../../reducers/detailsReducer";
import parse from "html-react-parser";
const Details = ({ item, pictures, detailsDispatch, loadItem, loading }) => {
  const { confirm } = useConfirm();
  const [show, setShow] = useState(false);
  const [galleryState, galleryDispatch] = useReducer(
    detailsReducer,
    detailsInitialState
  );
  const confirmAndRemovePicture = async (pictureId) => {
    const isConfirmed = await confirm(
      `Do you really want to remove this picture?`
    );

    if (isConfirmed) {
      await removePicture(pictureId);
    }
  };

  const removePicture = async (pictureId) => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.delete(`fossil-site-gallery/${pictureId}`, {
        albumId: item._id,
      });
      loadItem();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Media removed successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "BLOCK_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };

  const confirmAndArchivePicture = async (pictureId) => {
    const isConfirmed = await confirm(
      `Do you really want to archive this media?`
    );

    if (isConfirmed) {
      await changeStatusPicture(pictureId, "0");
    }
  };

  const confirmAndRestorePicture = async (pictureId) => {
    const isConfirmed = await confirm(
      `Do you really want to restore this media?`
    );

    if (isConfirmed) {
      await changeStatusPicture(pictureId, "1");
    }
  };

  const changeStatusPicture = async (pictureId, status) => {
    console.log("In block Item Function");
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.post(`fossil-site-gallery/change-status`, {
        id: pictureId,
        status,
      });
      loadItem();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Media ${
          status === "1" ? "restored" : "archived"
        } successfully.`,
        type: "success",
      });
    } catch (error) {
      detailsDispatch({
        type: "BLOCK_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        detailsDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };
  const loadGallery = async () => {
    if (item._id) {
      galleryDispatch({
        type: "FETCH_REQUEST",
      });
      try {
        const res = await axios.get(`fossil-site-gallery/${item._id}`); //
        galleryDispatch({
          type: "FETCH_SUCCESS",
          payload: res.data,
        });
        console.log(res.data, "154646");
      } catch (error) {
        galleryDispatch({
          type: "FETCH_FAILURE",
          payload: error,
        });
      }
    }
  };
  useEffect(() => {
    loadGallery();
  }, [item._id]);
  const getItems = () => {
    let items = [];

    if (item.altitude) {
      items = [
        ...items,
        { text: "Altitude", value: item.altitude, type: "text" },
      ];
    }

    if (item.note) {
      items = [...items, { text: "Note", value: item.note, type: "text" }];
    }
    if (item.period) {
      items = [...items, { text: "Period", value: item.period, type: "text" }];
    }

    return items;
  };

  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="ms-1 me-2">
                    <i className="fas fa-map mt-1 position-relative cartIcon">
                      {(item.status === "0" || item.status === 0) && (
                        <i className="fas fa-ban position-absolute banned4"></i>
                      )}
                    </i>
                  </div>

                  <div className="d-flex flex-column align-items-center justify-content-center ms-1 mt-1">
                    <span className="m-0 text-bold memberName text-red">
                      {item.title}
                    </span>
                  </div>
                  {item.saleableOptions && item.saleableOptions.price && (
                    <div className="d-flex flex-column  ms-1">
                      <h4 className="my-0 me-0 ms-1 text-bold text-primaryCream">
                        {" "}
                        ({item.saleableOptions.price} {getCurrencyCode()})
                      </h4>
                    </div>
                  )}
                </div>
              </Card.Title>

              <div className="card-tools">
                <div className=" text-right  mt-1 mt-xl-2 mt-lg-2 mt-md-2 pt-xl-1 pt-lg-1 pt-md-1 pt-0u">
                  <span className="badge badge-light me-1 text-dark">
                    Status :{" "}
                    <span class="text-secondary">
                      <ModuleDisplayBoolean
                        value={item.status}
                        trueValue="Enabled"
                        falseValue="Disabled"
                      />{" "}
                    </span>
                  </span>
                  {item.createdAt && (
                    <span class="badge badge-light me-1 text-dark">
                      Created Date :{" "}
                      <span class="text-secondary">
                        <ModuleDisplayDate value={item.createdAt} />{" "}
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </Card.Header>
            {console.log(item)}
            <Card.Body className="px-2 pt-1 pb-0">
              <Row>
                <Col className="mt-1 mb-1 ">
                  <Card bg="light" style={{ width: "14rem" }} className="mb-1">
                    <Card.Img
                      variant="top"
                      src={
                        process.env.REACT_APP_BACKEND_URL +
                        "public/" +
                        item.image
                      }
                    />
                    <div className="galleryImageBg">
                      <ReactFancyBox
                        thumbnail={
                          process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          item.image
                        }
                        image={
                          process.env.REACT_APP_BACKEND_URL +
                          "public/" +
                          item.image
                        }
                        caption="Album Cover"
                      />
                    </div>
                    <Card.Footer>
                      <h5 className="text-dark">
                        Total Media(s) :{" "}
                        <span className="text-bold text-pink">
                          {item.stats &&
                            item.stats.videosCount + item.stats.picturesCount}
                        </span>{" "}
                      </h5>
                    </Card.Footer>
                  </Card>
                  <StatsListing items={getItems()} />
                  {item.description && (
                    <>
                      <Alert
                        className="lightGray"
                        variant="secondary mb-0 pb-1 px-1 pt-0 messageWidth"
                      >
                        <span className="m-0 text-bold text-dark font-small">
                          Description:
                        </span>
                        <p className="font-small me-1 text-dark mb-0">
                          {parse(item.description)}
                        </p>
                      </Alert>
                    </>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="borderCream">
            <Card.Header className="ps-1 pe-2 py-0">
              <div className="d-flex  my-2 mx-2">
                <h5 className="text-bold">Fossil Sites Gallery </h5> &nbsp; &nbsp;{" "}
                <Button
                  title="Please click to add media"
                  variant="primary"
                  size="sm"
                  className="rounded-circle roundButton"
                  onClick={() => setShow(true)}
                >
                  <i className="fas fa-plus"></i>
                </Button>
              </div>
            </Card.Header>
            <Card.Body className="px-2 pb-0 pt-0">
              <Row className="circleMembersList">
                {galleryState.data.items &&
                galleryState.data.items.length > 0 ? (
                  <>
                    {galleryState.data.items.map((picture, index) => {
                      return (
                        <Col
                          key={index}
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          className="pt-1"
                        >
                          <GalleryItem
                            picture={picture}
                            loadItem={loadItem}
                            confirmAndRemovePicture={confirmAndRemovePicture}
                            confirmAndArchivePicture={confirmAndArchivePicture}
                            confirmAndRestorePicture={confirmAndRestorePicture}
                          />
                        </Col>
                      );
                    })}
                  </>
                ) : (
                  <Alert variant="warning" className="mb-0">
                    No records found.
                  </Alert>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <AddFossilPicture
        show={show}
        setShow={setShow}
        fossilId={item._id}
        loadItem={loadItem}
      />
    </>
  );
};

export default Details;
